import {AuthStore} from "./auth.store";
import {DistiplinesStore} from "./distiplines.store";
import {TableStore} from "./table.store";
import { noEditStore } from "./NoEditStore";

class Store {
    constructor() {
        this.auth = new AuthStore()
        this.distiplines = new DistiplinesStore()
        this.table = new TableStore(this)
        this.noEdit      = noEditStore;
    }
}

export const store = new Store()
